module.exports = __webpack_public_path__ + "static/media/blogback.f97f3dbe.webp";